// extracted by mini-css-extract-plugin
module.exports = {"formitemRow":"SelectOrderInfo_formitemRow__1GKWe","required":"SelectOrderInfo_required__rlYP8"};